import { useParams, useLocation } from 'react-router-dom';
import { embeddingService } from '@/ui-kit/services/embedding/EmbeddingService';
import { ConfiguratorParams } from '@/constants';
let _EMBEDDING_ERROR_COUNT = 0;

export function useConfiguratorRoute() {
  const { projectId, productId = 'default' } = useParams();
  const routerLocation = useLocation();
  let queryParams: URLSearchParams = new URLSearchParams(routerLocation.search);
  if (embeddingService.isEmbedded) {
    if (!embeddingService.initialLocation) {
      if (_EMBEDDING_ERROR_COUNT === 0) {
        console.error('Embedding is missing');
        _EMBEDDING_ERROR_COUNT++;
      }
    } else {
      const hostPageQueryParams = new URLSearchParams(embeddingService.initialLocation.search);
      // use link parameter from host page if it is available
      if (hostPageQueryParams.has(ConfiguratorParams.link)) {
        if (queryParams.has(ConfiguratorParams.link)) {
          queryParams.delete(ConfiguratorParams.link);
        }
        queryParams.append(ConfiguratorParams.link, hostPageQueryParams.get(ConfiguratorParams.link)!);
      }
    }
  }

  const token = queryParams.get('token') ?? '';
  const link = queryParams.get(ConfiguratorParams.link) ?? '';
  const draft = queryParams.get(ConfiguratorParams.draft) ?? '';
  const catalogId = queryParams.get(ConfiguratorParams.catalogId) ?? '';
  const configurationId = queryParams.get(ConfiguratorParams.configurationId) ?? '';
  const hideConfigurationControls = queryParams.get(ConfiguratorParams.hideConfigurationControls) === 'true';
  const background = queryParams.get(ConfiguratorParams.background);
  const configuratorMode = queryParams.get(ConfiguratorParams.mode);
  const hide3d = queryParams.get('hide3d') === 'true';

  if (!projectId) {
    throw new Error('Invalid projectId');
  }
  return {
    projectId: Number(projectId),
    productId: Number(productId),
    catalogId: catalogId ? Number(catalogId) : undefined,
    configurationId: configurationId,
    draft: Boolean(draft),
    link,
    token,
    hideConfigurationControls,
    background,
    configuratorMode,
    hide3d,
  };
}
